import { checkedTables, type Tables } from 'ErgoBot';

let loadingTables: Promise<Tables> | undefined;

/**
 * The fingering tables, fetched once per page. They are a chunk of their own,
 * so an app that never fingers a phrase never downloads them.
 */
export const loadFingeringTables = (): Promise<Tables> => {
  loadingTables ??= import('ErgoBot/data/ergobot-tables.json')
    .then((bundle) => checkedTables(bundle.default))
    .catch((error: unknown) => {
      // Let the next lesson try again instead of keeping the failure.
      loadingTables = undefined;
      throw error;
    });
  return loadingTables;
};
